export const TOLA = 11.664; // grams per tola — base divisor for all rate-of-work formulas

export const BAR_MAKING_RATES = {
  "1.000": 1200,
  "2.500": 1200,
  "5.000": 1200,
  5.832: 1200,
  "10.000": 1350,
  11.664: 1350,
  "15.550": 1350,
  "20.000": 1650,
  23.328: 1650,
  "31.100": 1650,
  "50.000": 1800,
  "58.320": 1800,
  "100.000": 2000,
};

export const COIN_KARAT_LOSS = { 24: 24, 12: 12, 8: 8 };

export const DEFAULT_PC_WEIGHT = 116.64;

// export const rateInit = () => ({
//   weight: "",
//   rate: "",
//   diff: "",
//   amount: "",
//   totalAmount: "",
//   postDate: "",
//   rw: "",
// });

export const cashInit = () => ({ currency: "PKR", amount: "" });

export const pcInit = () => ({
  brand: "Select",
  newBrandInput: "",
  showNewBrand: false,
  qty: "",
  diff: "",
  totalAmount: "",
  weight: DEFAULT_PC_WEIGHT.toFixed(3), // pre-filled: 116.640
  totalWeight: "",
  postDate: "",
  rw: "",
  //   rate: rateInit(),
});

export const labInit = () => ({
  report: "",
  weight: "",
  pureWeight: "",
  diff: "",
  diffAmount: "",
  totalAmount: "",
  testingPw: "",
  testingOa: "",
  testingOaQty: "",
  //   rate: rateInit(),
  ratePostDate: "",
  resendReport: true,
  rateRW: "",
});

export const barInit = () => ({
  brand: "select",
  weight: "",
  qty: "",
  making: "",
  diff: "",
  makingTotal: "",
  totalWeight: "",
  totalAmount: "",
  discount: "",
  //   rate: rateInit(),
});

export const coinInit = () => ({
  brand: "select",
  weight: "",
  qty: "",
  making: "",
  diff: "",
  totalAmount: "",
  totalWeight: "",
  karat: "",
  pureWeight: "",
  //   rate: rateInit(),
});

export const ginniInit = () => ({
  weight: "",
  refineAmount: "",
  refineCharges: "",
  report: "",
  pureWeight: "",
  totalAmount: "",
  totalWeight: "",
  paidAmount: "",
  //   rate: rateInit(),
  resendReport: true,
  rw: "",
});

export const silverInit = () => ({
  brand: "",
  barWeight: "",
  rawal: "",
  qty: "",
  making: "",
  totalWeight: "",
  totalAmount: "",
});

export const goldRWInit = () => ({
  weight: "",
  rate: "",
  amount: "",
  diff: "",
  postDate: "",
  totalAmount: "",
  rw: "",
  status: "",
});
export const silverRWInit = () => ({
  weight: "",
  rate: "",
  amount: "",
  diff: "",
  postDate: "",
  totalAmount: "",
  rw: "",
  status: "",
});

export const txInit = () => {
  return {
    receive: sideTx(),
    given: sideTx(),
  };
};

export const sideTx = (side) => ({
  type: side,
  cash: { amount: "", currency: "PKR" },
  pc: sectionInit(),
  lab: sectionInit(),
  bar: sectionInit(),
  coin: sectionInit(),
  ginni: sectionInit(),
  silver: sectionInit(),
  goldRW: goldRWInit(),
  silverRW: silverRWInit(),
});

export const sectionInit = () => ({ transactions: [], paidAmounts: {} });
